import { Box, Button, ButtonGroup } from "@chakra-ui/react";
import React from "react";
import { Form } from "react-final-form";
import { InputControl, Optional } from "../components/Form";

export interface IAdminSignupFormValues {
  email: string;
  name: string;
  lastname: string;
  phoneNumber: string;
}

interface IAdminSignupForm {
  onSubmit: (values: IAdminSignupFormValues) => void;
  initialValues?: Optional<IAdminSignupFormValues>;
}

export const AdminSignupForm: React.FC<IAdminSignupForm> = ({
    onSubmit,
    initialValues
}) => {
    const validate = (values) => {
        const errors: { [key: string]: string } = {};

        if (!values.email) {
            errors.email = "Fushë e detyruar";
        }

        if (!values.name) {
            errors.name = "Fushë e detyruar";
        }
        if (!values.lastname) {
            errors.lastname = "Fushë e detyruar";
        }

        if (
            values.phoneNumber &&
      !values.phoneNumber.match(/06\d\d\d\d\d\d\d\d/g)
        ) {
            errors.phoneNumber = "Telefoni duhet në formatin 06xxxxxxx";
        }

        return errors;
    };

    return (
        <Form
            onSubmit={ onSubmit }
            validate={ validate }
            initialValues={ initialValues }
            render={ ({
                handleSubmit,
                form,
                errors,
                submitting,
                pristine,
                values
            }) => (
                <Box as="form" onSubmit={ handleSubmit }>
                    <InputControl type="text" name="name" label="Emri" />

                    <InputControl type="text" name="lastname" label="Mbiemri" />

                    <InputControl type="email" name="email" label="Email" />
                    <InputControl type="text" name="phoneNumber" label="Telefoni" />

                    <ButtonGroup spacing={ 4 }>
                        <Button
                            isLoading={ submitting }
                            loadingText="Duke dërguar"
                            variantColor="teal"
                            type="submit"
                        >
                            Regjistro
                        </Button>
                        <Button
                            variantColor="teal"
                            variant="outline"
                            onClick={ form.reset }
                            isDisabled={ submitting || pristine }
                        >
                            Pastro
                        </Button>
                    </ButtonGroup>
                </Box>
            ) }
        />
    );
};
